<template>

	<div id="page-content">

		<div id="the-overflow">
			
			<router-link to="/products" class="button-type-f">Go back to products</router-link>

			<div class="row">
				<div class="col-md-4">
					<img :src="'static/images/products/' + product_info.code + '.jpg'" :alt="product_info.name" style="width: 100%; height: 100%; border: 1px solid #efefef;">
				</div>

				<div class="col-md-4 product-data">
					<h2>{{ product_info.name }}</h2>
					<p><strong>Category</strong> {{ product_info.category }}</p>
					<p v-if="!disabled"><strong>Price</strong> Php {{ formatMoney(product_info.price) }}</p>
				</div>

				<div class="col-md-4 product-data">
					<h2 >Product Specs</h2>
					<ul class="product-specs">
						<li><strong>Materials</strong> {{ product_info.materials }}</li>
						<li><strong>Socket Type</strong> {{ product_info.socket }}</li>
						<li><strong>Best For:</strong> {{ product_info.forplace }}</li>
						<li><strong>No. of Bulbs:</strong> {{ product_info.numbulb }}</li>
						<li><strong>{{ product_info.led }}</strong></li>
					</ul>
				</div>

			</div>
				
		</div>

	</div>

</template>

<script>
	export default{
		data(){
			return{
				product_info: {},

				disabled: true
			}
		},
		methods:{
			formatMoney: formatMoney,
		},
		created(){

			var self = this;
			var params = this.$route.params;
			
			$.ajax({
				url: 'static/php/products.php',
				type: 'post',
				data: params,
				success: function(data){
					data = JSON.parse(data);
					self.product_info = data;
				}
			});
			
		},
		mounted(){
			relativeTo('nav', this.$el);
		},
		watch: {
			'$route' (to, from){
				var self = this;
				var route = this.$route.fullPath;
				var params = this.$route.params;
				// console.log(params);
			}
		}
	}
</script>


// WEBPACK FOOTER //
// Product.vue?7de1c1de